// extracted by mini-css-extract-plugin
module.exports = {"container":"CorpusCreation_container__O0U9Y","buttonContainer":"CorpusCreation_buttonContainer__1VvhS","inputWrapper":"CorpusCreation_inputWrapper__1T2KP"};